export default __webpack_public_path__ + "static/climbing-5a96d44e2e2c182518ccc89bb17bbb6d.jpg";